import { Check } from "lucide-react";
import { PRICING } from "@/data/site";
import { SectionHead } from "./Sections";

export function Pricing() {
  return (
    <section id="pricing" data-testid="section-pricing" className="py-20 md:py-28 border-t border-[#1E2D4A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHead eyebrow="Pricing" title="Published prices. Unlimited users on every plan."
          text="You only pay while completions and commissioning are live. All prices in GBP, excluding VAT." />
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {PRICING.map((p) => (
            <div key={p.id} data-testid={`pricing-card-${p.id}`} className={`panel p-6 flex flex-col ${p.featured ? "border-amber-500 shadow-[0_0_24px_rgba(245,158,11,0.15)]" : ""}`}>
              {p.note && <span className="self-start font-mono text-[10px] uppercase tracking-wider bg-amber-500 text-[#080D1A] px-2 py-1 mb-4">{p.note}</span>}
              <h3 className="text-xl font-semibold text-slate-100">{p.name}</h3>
              <p className="num text-3xl font-bold text-slate-100 mt-4">{p.price}</p>
              <p className="text-xs text-slate-500 font-mono mt-1">{p.unit}</p>
              {p.tiers && (
                <div className="mt-5 border border-[#1E2D4A] divide-y divide-[#1E2D4A] text-sm">
                  {p.tiers.map(([a, b]) => <div key={a} className="flex justify-between px-3 py-2"><span className="text-slate-400">{a}</span><span className="num text-slate-200">{b}</span></div>)}
                </div>
              )}
              <ul className="mt-5 space-y-2.5 text-sm flex-1">
                {p.features.map((f) => <li key={f} className="flex gap-2 text-slate-300"><Check className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" />{f}</li>)}
              </ul>
              <a href="/#demo" data-testid={`pricing-cta-${p.id}`} className={`mt-6 text-center py-2.5 text-sm font-semibold ${p.featured ? "btn-accent" : "border border-[#334155] text-slate-200 hover:border-amber-500 transition-colors"}`}>
                {p.id === "enterprise" ? "Ask for a quote" : "Request a demo"}
              </a>
            </div>
          ))}
        </div>
        <div className="mt-6 panel p-6 flex flex-col md:flex-row md:items-center justify-between gap-4" data-testid="pricing-day-rate">
          <div>
            <h3 className="text-lg font-semibold text-slate-100">Setup and completions support</h3>
            <p className="text-sm text-slate-400 mt-1">Tag register build, template configuration, or completions management delivered by us.</p>
          </div>
          <span className="num text-xl font-semibold text-amber-400 shrink-0">Day rate</span>
        </div>
      </div>
    </section>
  );
}
